module.exports = __webpack_public_path__ + "media/images/icons/person-green-bc95b10cdd29ff30a0a6525eacaaa08f.svg";